/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Bridge the UI elements from jQuery UI that conflict with the ones from Bootstrap.
import tooltip from 'jquery-ui/ui/widgets/tooltip';
$.widget.bridge('uitooltip', tooltip);

import './common/bootstrap';

import '../plugins/jquery_steps/build/jquery.steps.js';
import '../plugins/datatables/jquery.dataTables.min.js';
import '../plugins/datatables/dataTables.bootstrap4.min.js';
import '../plugins/datatables/dataTables.buttons.min.js';
import '../plugins/datatables/dataTables.responsive.min.js';
import './frontend/jquery.wizard-init.js';
import './frontend/review';
import './frontend/search-form';
import SpecialtiesSearch from '@common/specialties';
import LicensesSearch from '@common/licenses';

$(document).ready(() => {
    SpecialtiesSearch.init();
    LicensesSearch.init();
});
